<template>
  <v-container fluid class="pa-4 rtl">
    <v-card class="header-card governance mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div
            class="text-h5 font-weight-bold text-blue-darken-3"
            style="color: #4a4f55"
          >
            احتياجات تعافي الحوكمة والإجراءات ذات الأولوية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            خطة التعافي المؤسسي والإجراءات العاجلة للحوكمة
          </div>
        </div>

        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          color="blue-darken-3"
          @click="showView('pillar-governance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">9/9</div>
          <div class="kpi-label">تحتاج تدخلاً في الحوكمة</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">3</div>
          <div class="kpi-label">أولويات تعافي عاجلة</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">12 شهر</div>
          <div class="kpi-label">الإطار الزمني المقترح</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card primary">
          <div class="kpi-value">$380K</div>
          <div class="kpi-label">تكلفة تعافي الحوكمة</div>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="table-card" elevation="1">
      <div class="table-header">أولويات تعافي الحوكمة</div>

      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>الأولوية العاجلة</th>
            <th>الإجراء المقترح</th>
            <th>المسؤول</th>
            <th>الإطار الزمني</th>
            <th>التكلفة التقديرية</th>
            <th>الحالة</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>{{ item.priority }}</td>
            <td>{{ item.action }}</td>
            <td>{{ item.responsible }}</td>
            <td>{{ item.timeline }}</td>
            <td class="font-weight-bold">{{ item.estimatedCost }}</td>
            <td>
              <v-chip
                :color="statusColor(item.status)"
                size="small"
                variant="flat"
              >
                {{ item.status }}
              </v-chip>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    priority: "تفعيل هيكل الإدارة",
    action: "تعيين مدير دائم + فريق قيادي",
    responsible: "وزارة الصحة",
    timeline: "1-3 أشهر",
    estimatedCost: "$30,000",
    status: "عاجل",
  },
  {
    name: "مستشفى الأمراض النفسية",
    priority: "إعادة تشغيل المرفق",
    action: "خطة إدارية كاملة + تمويل",
    responsible: "وزارة الصحة + WHO",
    timeline: "1-6 أشهر",
    estimatedCost: "$50,000",
    status: "عاجل",
  },
  {
    name: "مجمع الشيخ عثمان",
    priority: "تعزيز التنسيق",
    action: "ربط إلكتروني مع DHO + DHIS2",
    responsible: "مكتب الصحة",
    timeline: "3-6 أشهر",
    estimatedCost: "$20,000",
    status: "عالي",
  },
  {
    name: "مركز كود العثماني",
    priority: "تعيين مدير كفء",
    action: "إعلان وظيفي + تدريب",
    responsible: "وزارة الصحة",
    timeline: "1-3 أشهر",
    estimatedCost: "$15,000",
    status: "عالي",
  },
  {
    name: "مركز الممدارة",
    priority: "تطوير نظام المعلومات",
    action: "تحديث DHIS2 + تدريب",
    responsible: "مكتب الصحة",
    timeline: "3-6 أشهر",
    estimatedCost: "$10,000",
    status: "متوسط",
  },
  {
    name: "مركز المحاريق",
    priority: "بناء القدرات الإدارية",
    action: "تدريب القيادة + سياسات",
    responsible: "وزارة الصحة",
    timeline: "3-9 أشهر",
    estimatedCost: "$25,000",
    status: "عالي",
  },
  {
    name: "مركز عبد القوي",
    priority: "توثيق الإجراءات",
    action: "كتابة بروتوكولات + تدريب",
    responsible: "المرفق",
    timeline: "3-6 أشهر",
    estimatedCost: "$8,000",
    status: "متوسط",
  },
  {
    name: "مركز ماري ستبوس",
    priority: "إعادة التشغيل الكامل",
    action: "شراكة مع منظمة جديدة",
    responsible: "وزارة الصحة + UNFPA",
    timeline: "1-3 أشهر",
    estimatedCost: "$120,000",
    status: "عاجل",
  },
  {
    name: "جمعية حقوق الطفل",
    priority: "تعزيز الشفافية",
    action: "تقارير مالية + مشاركة مجتمعية",
    responsible: "الجمعية",
    timeline: "6-12 شهر",
    estimatedCost: "$12,000",
    status: "منخفض",
  },
];

const statusColor = (value) => {
  if (value === "عاجل") return "red";
  if (value === "عالي") return "orange";
  if (value === "متوسط") return "blue";
  return "green";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-radius: 18px;
  padding: 20px;
}

.header-card.governance {
  border-right: 5px solid #4a4f55;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.primary {
  background: #e8f0fb;
  color: #1a4a6b;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #1a2332 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
